import React from "react";
import { Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MainLogin.css"; // Ensure you create this CSS file for additional styles.
import { IoEye } from "react-icons/io5";
import { Link } from 'react-router-dom';

export default function MainLogin() {
  return (
    <div className="d-flex justify-content-center align-items-center"style={{marginTop:"300px"}}>
      <Card className="text-center shadow-lg rounded" style={{ width: '30rem' }}>
        <Card.Body>
          <div className="header d-flex flex-column justify-content-between" style={{ minHeight: '100px' }}>
            <Card.Text className="text-admin">
              Greetings, Super Admin!<br />
              Kindly choose your branch from the options below.
            </Card.Text>
            <Card.Title><h1>Login</h1></Card.Title>
            
          </div>
          <div className="section">
            <Card.Text className="text-left">Hira Lab Pakistan.</Card.Text>
            <div className="d-flex justify-content-start">
              <Link to='/signin'> {/* Link to Signin page */}
                <Button className="fancy-button" variant="primary" size="sm">
                  <IoEye /> View
                </Button>
              </Link>
            </div>
          </div>
          <hr />
          <div className="section">
            <Card.Text className="text-left">Hira Lab UK.</Card.Text>
            <div className="d-flex justify-content-start">
              <Link to='/signin'> {/* Link to Signin page */}
                <Button className="fancy-button" variant="primary" size="sm">
                  <IoEye /> View
                </Button>
              </Link>
            </div>
          </div>
          <hr />
          <div className="section">
            <Card.Text className="text-left">Bamber Lab.</Card.Text>
            <div className="d-flex justify-content-start">
              <Link to='/signin'> {/* Link to Signin page */}
                <Button className="fancy-button" variant="primary" size="sm">
                  <IoEye /> View
                </Button>
              </Link>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
